import { useTranslation } from 'react-i18next';

import { NOT_AVAILABLE } from 'core/constants';
import { useFormContext } from 'core/states';
import { GetManyResponse, IAutocompleteOption } from 'core/types';
import {
  CorporateLocationFormField as BaseCorporateLocationFormField,
  ICorporateLocationAutocompleteProps,
} from 'corporate/elements';
import { CorporateLocationType } from 'corporate/enums';
import { ICorporateLocationAutocomplete } from 'corporate/types';
import { ICustomerQuotePart } from 'quotes/types';

interface IProps extends ICorporateLocationAutocompleteProps {
  quotePart?: ICustomerQuotePart;
  isAlternateVersionEnabled: boolean;
  disabled?: boolean;
}

export const CorporateLocationFormField = ({
  quotePart,
  isAlternateVersionEnabled,
  disabled,
  ...rest
}: IProps) => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const partValue = watch('part');
  const manufacturerValue = watch('manufacturer');

  const partNumber = partValue?.number || quotePart?.partArr?.number;
  const manufacturerId = manufacturerValue?.id || quotePart?.manufacturerId;
  const uom = watch('uom') || quotePart?.uom;

  return (
    <BaseCorporateLocationFormField
      name="corporateLocation"
      label={t('labelShippingLocation')}
      placeholder={t('labelShippingLocation')}
      requestPayload={{
        viewBy: {
          partNumber,
          manufacturerId,
          uom,
        },
      }}
      queryOptions={{
        mapResult: (result: unknown): unknown => ({
          records: (result as GetManyResponse<ICorporateLocationAutocomplete>).records.map(
            (record) => ({
              ...record,
              addressName: record.name,
              vendorIdentifier: record.vendorId,
              inventoryTotalQty: record.inventoryQuantity,
            })
          ),
        }),
      }}
      getLabel={(option: IAutocompleteOption) =>
        [
          option.addressName || NOT_AVAILABLE,
          option.externalLocationId ? `(${option.externalLocationId})` : '',
        ]
          .filter(Boolean)
          .join(' ')
      }
      required={isAlternateVersionEnabled}
      disabled={disabled}
      disableClearable={isAlternateVersionEnabled}
      displayInventory
      isAlternateVersionEnabled={isAlternateVersionEnabled}
      type={CorporateLocationType.SHIPPING}
      {...rest}
    />
  );
};
